// extracted by mini-css-extract-plugin
export default {"header":"Header_header__prmlA","title":"Header_title__t2VQS","closed":"Header_closed__clSfi"};